export const endPoints = {
    PAYMENT_CUSTOM_TYPE: '/v1/payment-custom-type',
};
